import { Type } from 'class-transformer'
import { EnumEntity } from '..'

import { Person } from '.'

export class MaritalStatus extends EnumEntity {
  @Type(() => Person)
  people: Person[];
}
